// extracted by mini-css-extract-plugin
export default {"Box":"base-chart-error-module__Box--q0id6"};